import React from 'react';
import themeDark from "../../../shared/themeDark";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Button, IconButton } from "@material-ui/core";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from "react-hook-form";
import YellowBox from './YellowBox';
import CloseIcon from '@material-ui/icons/Close';

interface ChooseDialogPage2Props {
    setPage: any,
    goToAmbulanceDialog: any,
    reasonList: any[],
    setCalloutReasonValuesObj: any,
    calloutReasonValuesObj: any,
    cancelEndCallout: any
};

const useStyles = makeStyles((theme) => ({
    typoHead: {
        fontSize: 46,
        fontWeight: 700,
        color: "#FFF",
    },
    label: {
        fontSize: 30,
    },
    input: {
        height: 95,
        color: "#FFF",
    },
    icon: {
        color: 'white'
    },
    topContainer:{
        display: 'flex',
        justifyContent:'space-between'
    },
    iconButton:{
        padding:0
    }
}));

const ChooseDialogPage2: React.FC<ChooseDialogPage2Props> = ({
    setPage,
    goToAmbulanceDialog,
    setCalloutReasonValuesObj,
    calloutReasonValuesObj,
    reasonList,
    cancelEndCallout
}) => {
    const { handleSubmit, errors, control, getValues, setError } = useForm();

    const submitValues = () => {
        const valuesObj = getValues();
        if(valuesObj.calloutReason === "Other" && !valuesObj.otherreason){
            setError('otherreason', {message:"Notes are required"});
            return;
        }
        setCalloutReasonValuesObj(valuesObj);
        goToAmbulanceDialog();
    }

    const classes = useStyles();
    return (
        <MuiThemeProvider theme={themeDark}>
            <Paper
                style={{
                    height: "100vh",
                    overflowY: "scroll",
                    padding: "57px 74px",
                    borderRadius: 0,
                }}
            >
                <div className={classes.topContainer}>
                    <span>
                    <Button style={{ padding: 0, minWidth: 0, color: "#FFF", marginBottom: 50, marginLeft: -6 }} onClick={() => setPage(1)} ><KeyboardArrowLeftIcon /></Button>
                    </span>
                    <span>
                        <IconButton
                            aria-label="close"
                            className={classes.iconButton}
                            onClick={cancelEndCallout}>
                            <CloseIcon className={classes.icon} />
                        </IconButton>
                    </span>
                </div>
                
                <Typography variant="body1" component="div" className={classes.typoHead}>
                    What was the reason for delay?
                </Typography>
                <form onSubmit={handleSubmit(submitValues)} autoComplete="off" >
                    <div style={{ display: "flex", width: "100%", marginTop: 40 }}>
                        {reasonList.length > 0 && <Controller
                            name='calloutReason'
                            defaultValue={calloutReasonValuesObj?.calloutReason ? calloutReasonValuesObj.calloutReason
                                :reasonList[0].reasonForCalloutId}
                            control={control}
                            render={(props) => (
                                <>
                                    <div style={{ display: "flex", width: "50%" }}>
                                        <RadioGroup value={props.value} onChange={props.onChange}>
                                            {reasonList.map((item: any, i) => (i <= reasonList.length / 2 ? <FormControlLabel key={item.reasonForCalloutId} classes={{ label: classes.label }} value={item.reasonForCalloutId} control={<Radio />} label={item.name} /> : null))}
                                        </RadioGroup>
                                    </div>
                                    <div style={{ display: "flex", width: "50%" }}>
                                        <RadioGroup value={props.value} onChange={props.onChange}>
                                            {reasonList.map((item: any, i) => (i > reasonList.length / 2 ? <FormControlLabel key={item.reasonForCalloutId} classes={{ label: classes.label }} value={item.reasonForCalloutId} control={<Radio />} label={item.name} /> : null))}
                                            <FormControlLabel classes={{ label: classes.label }} value="Other" control={<Radio />} label="Other" />
                                        </RadioGroup>
                                    </div>
                                </>
                            )}
                            rules={{ required: true }}
                        />}
                    </div>
                    <Controller
                        name='otherreason'
                        defaultValue={calloutReasonValuesObj?.otherreason ? calloutReasonValuesObj.otherreason
                            :''}
                        control={control}
                        render={(props) => (
                            <TextField key='otherreason'
                                placeholder="Notes..."
                                variant="outlined"
                                multiline
                                rows={4}
                                InputProps={{
                                    classes: { input: classes.input },
                                }}
                                helperText={errors.otherreason ? "Notes are required" : ""}
                                style={{ marginTop: 42 }}
                                value={props.value}
                                onChange={props.onChange}
                                error={errors.otherreason}
                            />
                        )}
                    />
                    <div style={{ display: "flex", marginTop: 30, width: "100%", justifyContent: "flex-end" }}>
                        <YellowBox buttonProps={{ type: "submit" }} style={{ padding: "2px 0px" }} title="Continue" />
                    </div>
                </form>
            </Paper>
        </MuiThemeProvider>
    );
}

export default ChooseDialogPage2;